import * as Sentry from '@sentry/vue'

const ignoreMode = ['dev']

const { VITE_APP_ENV, VITE_APP_PKG_VERSION, VITE_APP_SENTRY_CLI } = import.meta.env

export const initSentry = (app, router) => {
  if (!ignoreMode.includes(VITE_APP_ENV) && VITE_APP_SENTRY_CLI === 'true') {
    Sentry.init({
      app,
      dsn: 'https://8e4d746384994deaafd489b7ffe4c440@sentry.kcallme.com:9999/5',
      environment: VITE_APP_ENV, // 不同的环境上报到不同的 environment 分类
      logErrors: false, // 是否开启sentry logger
      debug: false, //是否开启 debug 模式，开启debug，就会把信息打印到控制台上面
      attachStacktrace: true, // 是否开启堆栈跟踪，开启后跟着消息一起收集
      release: `${VITE_APP_ENV}@${VITE_APP_PKG_VERSION}`, // 版本控制 稍后介绍
      integrations: [
        new Sentry.Replay(),
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router)
        })
      ],
      replaysSessionSampleRate: 0.1,
      tracesSampleRate: 1.0, //  高访问量应用可以控制上报百分比
      initialScope: (scope) => {
        // // 手动设置用户信息
        // const mineUserInfo: any = mineUserStore.mineUserInfo
        // const accessToken = connectAuthStore.connectAuthInfo.accessToken
        // scope.setUser({
        //   username: mineUserInfo.userName,
        //   ...mineUserInfo
        // })
        // scope.setContext('登录信息', {
        //   token: accessToken
        // })
        return scope
      }
    })
  }
}
